import React from "react";
import PropTypes from "prop-types";
import { connectHits } from "react-instantsearch-dom";

import AlgoliaCardsPresenter from "presenters/AlgoliaCardsPresenter";
import FeaturedClips from "components/FeaturedClips";

const AlgoliaSearchResults = ({ carousel, hits }) => {
  const title = AlgoliaCardsPresenter.title(carousel);

  if (hits.length < 1) {
    return null;
  }

  window.prerenderReady = true;

  return <FeaturedClips items={hits} title={title} titleVariant="h1" />;
};

AlgoliaSearchResults.propTypes = {
  carousel: PropTypes.shape(),
  hits: PropTypes.arrayOf(PropTypes.shape()),
};

const SearchResults = connectHits(AlgoliaSearchResults);

export default SearchResults;
